import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { Button } from './Button';

interface HeroProps {
  onScrollToCheck: () => void;
}

export const Hero: React.FC<HeroProps> = ({ onScrollToCheck }) => {
  return (
    <section className="relative pt-36 pb-20 md:pt-40 md:pb-24 overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* Trust Badge - Enhanced Contrast */}
          <div className="inline-flex items-center gap-2 px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brand-200 bg-white/60 text-brand-900 text-[10px] md:text-xs font-bold tracking-wide uppercase mb-6 md:mb-8 backdrop-blur-md shadow-sm">
            <ShieldCheck size={14} className="text-brand-600 md:w-[16px] md:h-[16px]" />
            <span>Erkend letselschade specialist</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold text-slate-900 tracking-tight mb-4 md:mb-6 leading-[1.1] md:leading-[1.1]">
            U staat er <span className="text-brand-800">niet alleen</span> voor.
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl text-slate-600 mb-8 md:mb-10 max-w-2xl mx-auto font-light leading-relaxed px-2 md:px-0">
            Heeft u letsel opgelopen door een ander? Wij helpen u kosteloos aan de juiste vergoeding. Persoonlijk, respectvol en zonder zorgen.
          </p>

          <div className="flex flex-col items-center gap-4 md:gap-6 w-full px-4 md:px-0">
            <Button size="lg" fullWidth={true} onClick={onScrollToCheck} className="md:w-auto shadow-xl shadow-brand-900/5 text-lg h-14 md:h-auto">
              Doe de schadecheck
            </Button>
            
            <a href="tel:0201234567" className="text-slate-400 hover:text-slate-600 transition-colors text-sm font-medium flex items-center gap-2 py-2">
              Of bel direct voor advies: <span className="text-slate-900">020 - 123 45 67</span>
            </a>
          </div>
        </motion.div>

      </div>
      
      {/* Decorative calm background element - subtle blur */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[800px] h-[800px] rounded-full bg-brand-50/60 blur-[100px] opacity-60 mix-blend-multiply"></div>
        <div className="absolute top-[20%] -left-[10%] w-[600px] h-[600px] rounded-full bg-slate-100/80 blur-[80px] opacity-60 mix-blend-multiply"></div>
      </div>
    </section>
  );
};